export default "__VITE_ASSET__ET0RS$2I__"